import React from "react";

import {
  Grid,
  Paper,
  Card,
  Typography,
  Divider,
  Skeleton,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import useStyles from "./Dashboard.styles";
import WhatWeDo from "../../whatWeDo/WhatWeDo.component";
import { useUserContext } from "../../../context/UserContext";
import WorldClocks from "../../common/Clock/WorldClocks";
import NewsTicker from "../../common/NewsFeed/NewsTicker";
import { GoogleProvider } from "../../../context/GoogleContext";
import {
  GOOGLE_NEWS_SEARCH_QUERY1,
  GOOGLE_NEWS_SEARCH_QUERY2,
} from "../../../utils/constants";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.primary,
}));

const Dashboard = () => {
  const { classes } = useStyles();
  const { selectedUserDetailLoading } = useUserContext();

  return (
    <div className={classes.page}>
      {selectedUserDetailLoading ? (
        <>
          <Skeleton
            variant="rectangular"
            width="100%"
            height={56}
            animation="pulse"
            style={{ marginBottom: 8 }}
          />
          {Array.from({ length: 10 }).map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              width="100%"
              height={40}
              animation="pulse"
              style={{ marginBottom: 8 }}
            />
          ))}
        </>
      ) : (
        <Grid container justifyContent="center" alignItems="center">
          <Card
            style={{
              padding: "16px",
              width: "100%",
            }}
          >
            <Typography
              variant="h3"
              component="p"
              sx={{
                color: "#2f4f4f",
                fontSize: "1.8rem",
                textAlign: "center",
                marginBottom: "10px",
                fontWeight: "bold",
                padding: "10px 0",
                "&:hover": {
                  color: "gray",
                },
              }}
            >
              Welcome to Global TreasuryFin Suite
            </Typography>
            <Typography
              variant="subtitle1"
              component="p"
              sx={{
                color: "#555",
                fontSize: "1rem",
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              Available for every Region, SFC, Department, and Team. Delivers
              automated, efficient, and scalable modeling. Streamlines reporting
              and collaboration. Secure, interactive, and intelligent.
            </Typography>
            <Divider sx={{ borderBottomWidth: 4, mb: 4, borderColor: "red" }} />
            <GoogleProvider>
              <NewsTicker query={GOOGLE_NEWS_SEARCH_QUERY1} />
            </GoogleProvider>
            <br />
            <GoogleProvider>
              <NewsTicker query={GOOGLE_NEWS_SEARCH_QUERY2} />
            </GoogleProvider>
            <WorldClocks />
          </Card>
          <Grid size={{ xs: 12, md: 12 }} sx={{ display: "none" }}>
            <Item>
              <WhatWeDo />
            </Item>
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default Dashboard;
